// Redirect specific session and settings keys from localStorage to sessionStorage
// to prevent cross-tab leakage and session conflicts on the same browser.
(function () {
  const originalGetItem = Storage.prototype.getItem;
  const originalSetItem = Storage.prototype.setItem;
  const originalRemoveItem = Storage.prototype.removeItem;

  const sessionKeys = [
    'etpos_token',
    'etpos_token_expiry',
    'isAuthenticated',
    'user',
    'etpos_user_permissions',
    'etpos_business_timezone',
    'etpos_date_format',
    'etpos_time_format',
    'etpos_currency_precision',
    'etpos_quantity_precision',
    'etpos_currency_placement',
    'etpos_currency_symbol',
    'etpos_decimal_separator',
    'etpos_thousand_separator'
  ];

  Storage.prototype.getItem = function (key) {
    if (this === window.localStorage && sessionKeys.includes(key)) {
      return window.sessionStorage.getItem(key);
    }
    return originalGetItem.apply(this, arguments);
  };

  Storage.prototype.setItem = function (key, value) {
    if (this === window.localStorage && sessionKeys.includes(key)) {
      return window.sessionStorage.setItem(key, value);
    }
    return originalSetItem.apply(this, arguments);
  };

  Storage.prototype.removeItem = function (key) {
    if (this === window.localStorage && sessionKeys.includes(key)) {
      return window.sessionStorage.removeItem(key);
    }
    return originalRemoveItem.apply(this, arguments);
  };
})();
